import { OrganizationTier } from '@dadohr/shared/domainTypes/org';
import { ColoredChipLight } from '../../../../components/ColoredChip';

export const OrgTierChip = ({
  tier,
  small
}: {
  small?: boolean;
  tier: OrganizationTier;
}) => {
  return tier === OrganizationTier.FREE ? (
    <ColoredChipLight color="blue">
      {small ? 'F' : 'Free Tier'}
    </ColoredChipLight>
  ) : (
    <ColoredChipLight color="green">
      {small ? 'S' : 'Standard Tier'}
    </ColoredChipLight>
  );
};
